import { Icon } from '@iwoca/orion';
import DocumentRequirement from '../../DocumentRequirement/DocumentRequirement';
import messages from './BankStatements.messages';
import { FormattedMessage } from 'react-intl';
import { Text } from '@ui';
import { getCountry } from '@iwIntlProvider/CountryProvider';

const ManualUpload = ({
    toggleLinkBankAccount
}: {
    toggleLinkBankAccount?: () => void;
}) => {
    return (
        <DocumentRequirement documentType="bank statement" className="!p-0">
            <ul>
                <li>
                    <FormattedMessage {...messages.firstBullet} />
                </li>
                <li>
                    <FormattedMessage
                        {...messages.secondBullet}
                        values={{
                            strong: (chunks) => <strong>{chunks}</strong>
                        }}
                    />
                </li>
                {getCountry() === 'DE' && (
                    <>
                        <li>
                            <FormattedMessage {...messages.point3} />
                        </li>
                        <li>
                            <FormattedMessage {...messages.point4} />
                        </li>
                        <li>
                            <FormattedMessage {...messages.point5} />
                        </li>
                        <li>
                            <FormattedMessage {...messages.point6} />
                        </li>
                    </>
                )}
            </ul>

            {toggleLinkBankAccount && (
                <div className="mt-l flex items-start">
                    <Icon
                        icon="link"
                        className="mr-s mt-xs shrink-0 fill-structure-40"
                    />
                    <div className="inline-flex flex-wrap">
                        <Text className="text-structure-40">
                            <FormattedMessage {...messages.linkTrueLayer} />
                        </Text>
                        <button
                            onClick={toggleLinkBankAccount}
                            className="border-none bg-transparent px-0 font-med text-primary-40 underline hover:cursor-pointer"
                        >
                            <FormattedMessage {...messages.linkTrueLayerCTA} />
                        </button>
                    </div>
                </div>
            )}
        </DocumentRequirement>
    );
};

// eslint-disable-next-line import/no-default-export
export default ManualUpload;
